import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProjectArticle.css'
import { initSwiper } from '../Swiper'
import { sideBarProjectArray } from '../components/projectArray';

const ForestAndEconomies = () => {

        useEffect(() => {
            // Initialize Swiper
            initSwiper();
        }, []);

        return (
            <div>
                <section className="project-hero F-and-E-hero">
                    <div className="project-name">
                        <h2>Forests and Economies</h2>
                    </div>
                </section>

                <div className="project-article-container">
                    <div className="gecci-project-article">
                        <div className="side-bar">
                            <h3>Other Projects</h3>
                            { sideBarProjectArray.map((project) => (
                                <div key={project.id} className='side-bar-project-list'>
                                    <div className="project-list">
                                        <Link to={project.url} >{project.title}</Link>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <article className="project-article">
                            <div className="article">
                                <h3>Forests and Economies</h3>
                                <div className="article-content">
                                    <div className="article-text">
                                        
                                        <p>
                                         GRENCHI and the Forestry and Wildlife Department, Anambra State Ministry of Environment, came together to mark this year's International Day of Forests (IDF) with a practical, hands-on training designed to put trees and livelihoods back in the hands of local communities.
                                        </p>

                                        <h4 className="bold">About the Programme</h4>

                                        <p>
                                            This year's global theme, "Forests and Economies" asks a critical question: how do we grow forests and grow people at the same time? The answer, we believe, begins at the nursery level.
                                            <br />
                                            <br />
                                            On March 21, 2026, the Green Environment and Climate Change Initiative (GRENCHI) partnered with the Forestry and Wildlife Department of Anambra State's Ministry of Environment to deliver a full-day agroecological training for farmers, youth and people in academia. The training was rooted in one idea: when people understand how to raise trees from seed to seedling, they become agents of both ecological restoration and economic opportunity.
                                            <br />
                                            <br />
                                            <span className="italics bold text-green">
                                                "A forest economy doesn't begin with a chainsaw. It begins with a seed, a nursery bed, and someone who knows what to do with both."
                                            </span>
                                        </p>

                                        <h4>Programme at a Glance</h4>
                                        <div className="article-video">
                                            <iframe src="https://www.youtube.com/embed/6gs6ogcndVg" title="Practical Training to Commemorate International Day of Forests 2026 _Forest and Economies" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                        </div>
                                        
                                        <h4>Why It Matters</h4>
                                        <p>
                                            Forests are not just carbon stores or biodiversity hotspots, they are economic infrastructure. Timber, fruits, medicinal plants, fodder and ecosystem services all flow from healthy, well-managed forests. Across Anambra State and the wider Nigeria landscape, deforestation and land degradation are quietly shrinking the natural capital communities depend on.
                                            <br />
                                            <span className='bold'>Agroforestry - </span> the practice of integrating trees into farming systems is one of the most evidence-backed, low-input strategies for reversing this trend. It increases farm income, restores degraded soils, sequesters carbon and improves food security. But it only works when farmers and land owners have the technical skills to propagate, manage and maintain trees on their own land.
                                            <br />
                                            <br />
                                            That is precisely what this training was designed to deliver.
                                        </p>

                                        <div className="article-img">
                                            <img src="../img/F-and-E/F-and-E_1.jpeg" alt="Dr.Ropo Engaging with the people of Ebenebe." />
                                        </div>
                                        
                                        <h4>What Participants Learned</h4>
                                        <p>Eight Practical Skills for Forest Entrepreneurs Participants were trained in the full nursery-to-field pipeline </p>
                                        
                                        <div className="article-grid">
                                            <div className="article-grid-box">
                                                <div className="grid-box-number">01</div>
                                                <h5 className="bold">Tree seed collection and selection</h5>
                                                <p>How to identify quality mother trees, harvest seeds at peak maturity and select for genetic diversity.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">02</div>
                                                <h5 className="bold">Seed viability testing</h5>
                                                <p>Simple field tests float tests, cut tests, germination trials to check whether seeds are worth planting before resources are committed.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">03</div>
                                                <h5 className="bold">Climate-smart agroforestry practices</h5>
                                                <p>Matching the right tree species to the right farming system shade trees, windbreaks, alley cropping and multi-strata systems suited to local conditions.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">04</div>
                                                <h5 className="bold">Grafting techniques</h5>
                                                <p>Hands-on practice with cleft grafting and veneer grafting gave participants the tools to multiply high-value fruit and timber trees.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">05</div>
                                                <h5 className="bold">Budding</h5>
                                                <p>A faster propagation method of citrus and mango allowing participants to produce more planting materials from less stock.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">06</div>
                                                <h5 className="bold">Seed treatments</h5>
                                                <p>Scarification, soaking and hot-water treatments to break dormancy and improve germination rates for hard-coated or dormant seeds.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">07</div>
                                                <h5 className="bold">Nursery bed preparation</h5>
                                                <p>How to set up productive, disease-resistant nursery beds using locally available materials the foundation of any community tree nursery.</p>
                                            </div>

                                            <div className="article-grid-box">
                                                <div className="grid-box-number">08</div>
                                                <h5 className="bold">Potting and root management</h5>
                                                <p>Soil mix ratios, container selection, root pruning and hardening-off seedlings to ensure high survival rates after field transplanting.</p>
                                            </div>
                                        </div>

                                        <h5>Our Approach</h5>
                                        <p>
                                            The training was designed around the principle that agroecological knowledge is best transferred through practice, not lecture. Participants did not sit through presentations, they worked in the nursery, handled seeds, made grafts, prepared beds and left with skills.
                                            <br />
                                            <br />
                                            Participants were also equipped to establish or improve their own community tree nurseries, creating a direct pathway from training to income-generating activity in their localities.
                                        </p>

                                        <div className="article-img">
                                            <img src="../img/F-and-E/F-and-E_3.jpeg" alt="Dr.Ropo Engaging with the people of Ebenebe." />
                                        </div>

                                        <h5>Looking Forward</h5>
                                        <p>
                                            A single training day is a seed, not a harvest. GRENCHI and the Forestry and Wildlife Department remain committed to following up with trained participants, supporting the establishment of community nurseries and expanding this programme to more communities across Anambra State.
                                            <br />
                                            <br />
                                            We believe that building a forest economy in Nigeria starts with building the human capacity to restore and manage forests at the community level. Every participant who leaves with the skill to graft a tree, test a seed or set up a nursery bed is a step toward that future.
                                        </p>
                                    </div>                       
                                    
                                </div>
                            </div>

                        </article>

                    </div>
                </div>
            </div>
        );
    }

export default ForestAndEconomies;
